module.exports = __webpack_public_path__ + "static/media/44_B.bfeda826.png";